import { Accordion, Grid } from "@mui/material";
import React, { Dispatch, FC, SetStateAction } from "react";
import ObjectiveMain from "./ObjectiveMain";
import ObjectiveDetails from "./ObjectiveDetails";
import {
  iObjetivoAprendizaje,
  SelectedIndicator,
} from "../../interfaces/ObjetivosAprendizaje/iObjetivosAprendizaje";
import { useActividadesContext } from "../UmmIACategories/Hook/useActividades";
import { ObjColors } from "./SingleType";

interface Props {
  objetivo: iObjetivoAprendizaje;
  selectedIndicators: SelectedIndicator;
  expandedPanel: string | null;
  setExpandedPanel: Dispatch<SetStateAction<string | null>>;
  handleIndicatorSelect: (idObjetivo: string, indicador: string) => void;
  handleToggleAllIndicators: (
    idObjetivo: string,
    allIndicators: string[]
  ) => void;
  handleRemoveObjectiveFromProject: (objetivo: iObjetivoAprendizaje) => void;
  handleAddObjectiveToProject: (objetivo: iObjetivoAprendizaje) => void;
  setSelectedIndicators: Dispatch<SetStateAction<SelectedIndicator>>;
  boxColors: ObjColors;
}

const SingleObjective: FC<Props> = ({
  objetivo,
  selectedIndicators,
  expandedPanel,
  setExpandedPanel,
  handleAddObjectiveToProject,
  handleIndicatorSelect,
  handleRemoveObjectiveFromProject,
  handleToggleAllIndicators,
  setSelectedIndicators,
  boxColors,
}) => {
  const { objetivosSeleccionados } = useActividadesContext();

  const isExpanded = expandedPanel === objetivo.id_objetivo;
  // Verifica si se ha seleccionado al menos un indicador
  const hasSelectedIndicator =
    selectedIndicators[objetivo.id_objetivo]?.length > 0;

  const allSelected =
    Array.isArray(objetivo.indicadores) &&
    selectedIndicators[objetivo.id_objetivo]?.length ===
      objetivo.indicadores.length;

  return (
    <Grid item xs={12} md={4}>
      <Accordion
        expanded={isExpanded}
        onChange={(e, expanded) =>
          setExpandedPanel(expanded ? objetivo.id_objetivo : null)
        }
        sx={{
    border: objetivosSeleccionados[objetivo.id_objetivo]
      ? "3px solid #FBC02D"
      : `2px dashed ${boxColors.border}`,
    borderRadius: "10px !important",       
    overflow: "hidden",                      
    backgroundColor: objetivosSeleccionados[objetivo.id_objetivo]
      ? "rgba(248, 173, 12, 0.1)"
      : `${boxColors.background}`,
    "&::before": {
      display: "none",
    },
    "&:hover": {
      boxShadow: objetivosSeleccionados[objetivo.id_objetivo]
        ? "4px 8px 10px rgba(248, 173, 12, 0.5)"
        : "4px 8px 10px rgba(0, 124, 119, 0.5)",
    },
  }}
      >
        <ObjectiveMain objetivo={objetivo} isExpanded={isExpanded} color={boxColors.letter} />
        <ObjectiveDetails
          objetivo={objetivo}
          handleIndicatorSelect={handleIndicatorSelect}
          selectedIndicators={selectedIndicators}
          handleAddObjectiveToProject={handleAddObjectiveToProject}
          handleToggleAllIndicators={handleToggleAllIndicators}
          handleRemoveObjectiveFromProject={handleRemoveObjectiveFromProject}
          hasSelectedIndicator={hasSelectedIndicator}
          allSelected={allSelected}
          setSelectedIndicators={setSelectedIndicators}
          color={boxColors.letter}
        />
      </Accordion>
    </Grid>
  );
};

export default SingleObjective;
